import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export interface PlantChoice {
  id: string;
  code: string;
  name: string;
}

export interface PlantScope {
  // The active plants the signed-in user may work in
  plants: PlantChoice[];
  // A new sales order, purchase order or work order needs a plant
  required: boolean;
  // The plant that is used without asking, when there is only one
  defaultPlantId: string | null;
  // The user is limited to some plants
  restricted: boolean;
}

const NONE: PlantScope = { plants: [], required: false, defaultPlantId: null, restricted: false };

export const usePlantScope = () => {
  const query = useQuery<PlantScope>({
    queryKey: ['plant-scope'],
    queryFn: async () => (await api.get('/plant-scope')).data,
    staleTime: 60_000,
  });
  return { scope: query.data ?? NONE, isLoading: query.isLoading };
};
